import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import {
  faEnvelope,
  faEye,
  faEyeSlash,
  faLock,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { registerUser } from "../../services/authFn";
import { emailRegex } from "../../lib/variable";
import AppLoader from "../loader/loader";

function Signup() {
  const showAlert = (title, text, icon) => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: "OK",
    });
  };

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [inputValues, setInputValues] = useState({
    username: "",
    email: "",
    contact: "",
    password: "",
  });

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setInputValues((prev) => ({ ...prev, [id]: value }));
  };

  const handlePhoneChange = (contact) => {
    setInputValues((prev) => ({ ...prev, contact }));
  };

  const handleRegister = async () => {
    const { username, email, contact, password, confirmPassword } = inputValues;

    if (!username || !email || !contact || !password || !confirmPassword) {
      showAlert("Error", "All fields are required.", "error");
      return;
    }
    if (password !== confirmPassword) {
      showAlert("Error", "Passwords do not match.", "error");
      return;
    }
    if (!emailRegex.test(email)) {
      showAlert("Error", "Invalid email format.", "error");
      return;
    }

    const payload = {
      email: inputValues.email,
      purpose: "Registration",
      role: "User",
    };
    setIsLoading(true);
    try {
      const response = await registerUser(payload);
      if (response.status === 200 || response.status === 201) {
        showAlert("Success", response.data.message, "success");
        navigate("/otp", { state: inputValues });
      } else {
        showAlert("Error", response.data.message, "error");
      }
    } catch (error) {
      showAlert(
        "Error",
        error?.message || "An error occurred during registration.",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <section className="signup-section">
        <div className="hero-signup">
          <div className="container-signup">
            <div className="box-signup">
              <h1 className="signup-pg">Signup</h1>
              <div className="container">
                <div className="row">
                  {/* Full Name Field */}
                  <div className="col-md-12 form-group">
                    <label htmlFor="username">Full Name</label>
                    <div className="icon-input">
                      <FontAwesomeIcon icon={faUser} className="input-icon" />
                      <input
                        type="text"
                        id="username"
                        placeholder="Enter your full name"
                        className="form-control"
                        value={inputValues.username}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  {/* Email Field */}
                  <div className="col-md-6 form-group">
                    <label htmlFor="email">Email</label>
                    <div className="icon-input">
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        className="input-icon"
                      />
                      <input
                        type="email"
                        id="email"
                        placeholder="email@demo.com"
                        className="form-control"
                        value={inputValues.email}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  {/* Phone Field */}
                  <div className="col-md-6 form-group">
                    <label htmlFor="phone">Phone</label>
                    <PhoneInput
                      country={"us"}
                      value={inputValues.contact}
                      onChange={handlePhoneChange}
                      inputClass="input-field"
                    />
                  </div>

                  {/* Password Field */}
                  <div className="col-md-6 form-group">
                    <label htmlFor="password">Password</label>
                    <div className="icon-input">
                      <FontAwesomeIcon icon={faLock} className="input-icon" />
                      <input
                        type={passwordVisible ? "text" : "password"}
                        id="password"
                        placeholder="Enter your password"
                        className="form-control"
                        value={inputValues.password}
                        onChange={handleInputChange}
                      />
                      <FontAwesomeIcon
                        icon={passwordVisible ? faEyeSlash : faEye}
                        className="eye-icon"
                        onClick={togglePasswordVisibility}
                      />
                    </div>
                  </div>

                  {/* Confirm Password Field */}
                  <div className="col-md-6 form-group">
                    <label htmlFor="confirmPassword">Confirm Password</label>
                    <div className="icon-input">
                      <FontAwesomeIcon icon={faLock} className="input-icon" />
                      <input
                        type={passwordVisible ? "text" : "password"}
                        id="confirmPassword"
                        placeholder="Confirm your password"
                        className="form-control"
                        value={inputValues.confirmPassword}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-12 form-group Remember_me">
                    {/* <label className="switch">
                      <input
                        type="checkbox"
                        checked={rememberMe}
                        onChange={() => setRememberMe(!rememberMe)}
                      />
                      <span className="slider"></span>
                    </label>
                    <label>Remember Me</label> */}
                  </div>

                  {/* Submit Button */}
                  <div className="col-md-12 form-group">
                    <button className="btn-1" onClick={handleRegister}>
                      Sign Up
                    </button>
                    <div className="register-link">
                      <p>
                        Already have an account? <span onClick={() => navigate("/signin")}>Login</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Signup;
